<template>
  <div class="hjqy">
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i4"></i></div><p>{{data.catename}}获奖企业</p>
    </div>

    <div class="hjqy_detail clearfix">
      <div class="img_wrap">
        <div class="photo">
          <img :src="domain+data.litpic" alt="" v-if='data.litpic'>
          <p class="name">{{data.title}}</p>
        </div>
        <p class="zw">{{data.shorttitle}}</p>
      </div>
      <div class="text_wrap">
        <div class="text_title">
          <p>{{data.copyfrom}}</p>
         <!--  <p>公司业务：{{data.author}}</p> -->
        </div>
        <div class="text_detail" >
          <p class="yw">公司业务：{{data.author}}</p>
          <div class="text_detail_content" v-html='data.content'>
            移动互联网与创新创业激活经济新元素。在二者的交汇地带，共享单车横空出世，成为创新创业热门领域。共享单车带给人们方便与快捷，打通城市交通“最后一公里”，创造清洁城市。共享单车乘着共享经济之风，以其随用随骑、网上支付的便捷性，迅速俘获人心。
          </div>
          <!-- <div class="text_detail_title">
            未来发展潜力
          </div>
          <div class="text_detail_content">
            移动互联网与创新创业激活经济新元素。在二者的交汇地带，共享单车横空出世，成为创新创业热门领域。共享单车带给人们方便与快捷，打通城市交通“最后一公里”，创造清洁城市。共享单车乘着共享经济之风，以其随用随骑、网上支付的便捷性，迅速俘获人心。
          </div>
          <div class="text_detail_title">
            未来发展潜力
          </div>
          <div class="text_detail_content">
            移动互联网与创新创业激活经济新元素。在二者的交汇地带，共享单车横空出世，成为创新创业热门领域。共享单车带给人们方便与快捷，打通城市交通“最后一公里”，创造清洁城市。共享单车乘着共享经济之风，以其随用随骑、网上支付的便捷性，迅速俘获人心。
          </div>
          <div class="text_detail_title">
            未来发展潜力
          </div>
          <div class="text_detail_content">
            移动互联网与创新创业激活经济新元素。在二者的交汇地带，共享单车横空出世，成为创新创业热门领域。共享单车带给人们方便与快捷，打通城市交通“最后一公里”，创造清洁城市。共享单车乘着共享经济之风，以其随用随骑、网上支付的便捷性，迅速俘获人心。
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ljhjqy',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      year:''
    }
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=getdetail',
       {
          id:this.$route.params.id
        },
       {emulateJSON : true})
   .then((response) => {
         this.data=response.body.data
         console.log(response)
     })
  }
}
</script>

<style scoped>
  i.i4{
    width: 0.33rem;
    height: 0.32rem;
    background-position: -0.1rem -2.09rem;
  }
  .hjqy_detail{
    padding: 0 0.42rem;
  }
  .img_wrap{
    width: 2rem;
    float: left;
    margin:0 0.1rem 0.1rem 0;
    background-color: #ffd200;
  }
  .img_wrap .photo{
    padding: 0.05rem;
  }
  .img_wrap img{
    width: 100%;
    display: block;
  }
  .img_wrap .name{
    font-size: 0.2454rem;
    color: #231f20;
    padding: 0.05rem 
  }
  .img_wrap .zw{
    background-color: #6d6e71;
    color: #fff;
    font-size: 0.185rem;
    padding: 0.05rem 0.1rem;
  }
  .text_wrap{
    
  }
  .text_title{
    font-size: 0.22rem;
    color: #6d6e71;
    padding-bottom: 0.14rem;
    border-bottom: 0.02rem solid #ffd308;
    margin-bottom: 0.2rem;
    font-weight: bold;
  }
  .yw{
     font-size: 0.22rem;
    color: #6d6e71;
    margin-bottom: 0.2rem;
    font-weight: bold;
  }
  .text_detail_title{
    font-size: 0.22rem;
    color: #6d6e71;
    margin-bottom: 0.04rem;
  }
  .text_detail_content{
    font-size: 0.2rem;
    color: #000;
    margin-bottom: 0.1rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/hjqy_detail.vue